/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_View_TitleInputs */

const es_feedback_modal_view_title = /** @type {(inputs: Feedback_Modal_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detalle del Feedback`)
};

const en_feedback_modal_view_title = /** @type {(inputs: Feedback_Modal_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feedback Details`)
};

/**
* | output |
* | --- |
* | "Feedback Details" |
*
* @param {Feedback_Modal_View_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_view_title = /** @type {((inputs?: Feedback_Modal_View_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_View_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_view_title(inputs)
	return en_feedback_modal_view_title(inputs)
});
export { feedback_modal_view_title as "feedback.modal.view_title" }